import ModelState, {localised} from './_util/model';

@localised
class UserReferralState extends ModelState {
  get url() { return '/referral'; }
  get singular() { return 'referral'; }
  get plural() { return 'referrals'; }
  get defaultQuery() { return 'suggestions=1'; }
}

export default UserReferralState;



// WEBPACK FOOTER //
// ./spa/state/user-referral.jsx